import React, { useEffect, useState } from "react";

import moment from "moment";

import DatePicker from "../../../Common/DatePicker/DatePicker";

import { ReactComponent as CalendarLineIcon } from "../../../../assets/images/subscriptions/calendar-line.svg";

import "./TestSpendPeriodControl.css";

const formatDateRangeLabel = (startDate, endDate) => {
  const start = moment(startDate);
  const end = moment(endDate);

  if (!start.isValid() || !end.isValid()) {
    return "";
  }

  return `${start.format("MMM D, YYYY")} - ${end.format("MMM D, YYYY")}`;
};

export default function TestSpendPeriodControl({
  startDate,
  endDate,
  onPeriodChange,
}) {
  const rangeLabel = formatDateRangeLabel(startDate, endDate);
  const [dateSelected, setDateSelected] = useState(rangeLabel);
  const [prevDateSelected, setPrevDateSelected] = useState(rangeLabel);

  useEffect(() => {
    const nextLabel = formatDateRangeLabel(startDate, endDate);
    setDateSelected(nextLabel);
    setPrevDateSelected(nextLabel);
  }, [startDate, endDate]);

  const handleDateChange = (nextStartDate, nextEndDate) => {
    if (onPeriodChange) {
      onPeriodChange(nextStartDate || "", nextEndDate || "");
    }
  };

  return (
    <DatePicker
      handleSearchDate={handleDateChange}
      value={dateSelected}
      onChange={setDateSelected}
      prevValue={prevDateSelected}
      setPrevValue={setPrevDateSelected}
      searchOnClear
      popoverPlacement="bottomLeft"
      datePickerDisplayProps={{
        displayClassName: `TestSpendPeriodControl__DatePicker${
          dateSelected ? " TestSpendPeriodControl__DatePicker--active" : ""
        }`,
        showText: true,
        iconTooltipTitle: "Filter by date",
        emptyPlaceholder: "Select date range",
        customCalendarIcon: (
          <CalendarLineIcon className="TestSpendPeriodControl__DatePickerIcon" aria-hidden />
        ),
      }}
    />
  );
}
